import React, { Component } from "react";
import {
  profile,
  alert,
  float,
  toFixed,
  GET,
  POST,
  PUT,
  loading,
  Status,
  required,
  Select,
  Pagination,
  Navbar,
  Modal,
  copyText,
  maskAccount,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";
// สีของสถานะ KYC ตามค่าที่ Primerlo คืน (เหมือนหน้า admin customers)
const KYC_COLORS = {
  none: "secondary",
  pending: "warning",
  review: "warning",
  rejected: "danger",
  expired: "danger",
  bank_required: "orange",
  approved: "success",
};
export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_currency: "THB",
      filter_is_blacklist: "",

      hover_index: -1,

      data: [],
      count: 0,
      page: 1,
      page_size: 10,
      loaded: false,
      data_bank: [],

      id: "",
      uid: "",
      broker_id: "",
      customer_ref: "",
      name_th: "",
      name_en: "",
      email: "",
      deposit_fee_type: "",
      deposit_fee_value: 0,
      withdrawal_fee_type: "",
      withdrawal_fee_value: 0,
      is_vat: false,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      company_name: "",
      company_address: "",
      company_website: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      remark: "",
      callback_url: "",
      is_active: true,
      gateway_register: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_currency, filter_is_blacklist, page_size } =
      this.state;
    loading(true);
    const result = await GET("v1/admin/customers", {
      page_size: page_size,
      page: page,
      data_search: filter_search,
      currency: filter_currency,
      is_blacklist: filter_is_blacklist,
    });
    loading(false);

    // ยิงไม่ผ่านต้องคงข้อมูลเดิมไว้ ไม่ใช่ล้างตารางเป็น No data โดยไม่บอกสาเหตุ
    if (result?.status !== true) {
      this.setState({ loaded: true });
      return;
    }

    this.setState({
      loaded: true,
      page: page,
      data: result.data || [],
      count: result.pagination?.count || 0,
    });
  };
  // ขอลิงก์หน้า KYC ตัวกลางของเรา (/kyc?t=token อายุ 24 ชม.) ออกให้เฉพาะลูกค้าของ broker ที่ใช้ primerlo
  // copy=false เปิดแท็บใหม่ให้ลูกค้าทำ KYC ต่อ · copy=true คัดลอกลิงก์ไว้ส่งลูกค้า (GET แจ้ง error เองเมื่อไม่สำเร็จ)
  OpenKyc = async (item, copy = false) => {
    loading(true);
    const result = await GET(`v1/admin/customers/${item.uid}/kyc-link`);
    loading(false);
    if (!result?.status || !result.data?.kyc_url) return;
    if (copy) return copyText(result.data.kyc_url);
    window.open(result.data.kyc_url, "_blank", "noopener");
  };
  // สถานะ KYC กับ Primerlo (customers_gatewaies.kyc_status) ลูกค้าที่ไม่เคยเข้า Primerlo แสดง "-" ปุ่มเปิดหน้า KYC อยู่ใน modal แก้ไข
  renderKyc = (item) => {
    const kyc = item.gateway_register?.find((g) => g.gateway_name === "primerlo")?.kyc_status;
    return kyc ? Status(kyc, KYC_COLORS[kyc] || "secondary") : <span className="pu-none">-</span>;
  };
  GetBank = async (gateway) => {
    const result = await GET("v1/admin/banks", {
      page_size: 100000,
      page: 0,
      data_search: "",
      gateway: gateway,
    });
    if (result?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      this.setState({
        data_bank: result.data
          .filter((e) => e.bank_gateway_mappings)
          .sort((a, b) => {
            const indexA = popularBankCodes.indexOf(a.code);
            const indexB = popularBankCodes.indexOf(b.code);

            if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
            } else if (indexA !== -1) {
              return -1; // a อยู่ใน popular → ให้มาก่อน
            } else if (indexB !== -1) {
              return 1; // b อยู่ใน popular → ให้มาก่อน
            } else {
              return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
            }
          })
          .map((e) => ({
            value: e.code,
            label: e.name_en,
            country: e.country,
            front: (
              <img
                alt="bank"
                src={require(`../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`)}
                width={18}
                height={18}
                style={{ marginRight: 6 }}
              />
            ),
          })),
      });
    } else {
      loading(false);
    }
  };
  CreateUpdate = async () => {
    const {
      uid,
      broker_id,
      currency,
      name_th,
      customer_ref,
      name_en,
      email,
      deposit_fee_type,
      deposit_fee_value,
      withdrawal_fee_type,
      withdrawal_fee_value,
      is_vat,
      bank_code,
      bank_account_name_th,
      bank_account_name_en,
      bank_account_number,
      company_name,
      company_address,
      company_website,
      contact_name,
      contact_email,
      contact_phone,
      remark,
      callback_url,
      is_active,
    } = this.state;
    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please input Broker");
      return;
    } else if (!name_th.trim()) {
      alert("", "warning", "Warning", "Please input Name TH");
      return;
    } else if (!name_en.trim()) {
      alert("", "warning", "Warning", "Please input Name EN");
      return;
    } else if (!bank_code.trim()) {
      alert("", "warning", "Warning", "Please select Bank Name");
      return;
    } else if (!bank_account_number.trim()) {
      alert("", "warning", "Warning", "Please input Account Number");
      return;
    } else if (!bank_account_name_th.trim()) {
      alert("", "warning", "Warning", "Please input Account NameTH");
      return;
    } else if (!bank_account_name_en.trim()) {
      alert("", "warning", "Warning", "Please input Account Name EN");
      return;
    } else if (!currency.trim()) {
      alert("", "warning", "Warning", "Please select Currency");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        broker_id,
        currency,
        customer_ref,
        name_th,
        name_en,
        email,
        deposit_fee_type,
        deposit_fee_value: Number(deposit_fee_value),
        withdrawal_fee_type,
        withdrawal_fee_value: Number(withdrawal_fee_value),
        is_vat,
        bank_code,
        bank_account_name_th,
        bank_account_name_en,
        bank_account_number,
        company_name,
        company_address,
        company_website,
        contact_name,
        contact_email,
        contact_phone,
        remark,
        callback_url,
        is_active,
      };

      let result = !uid
        ? await POST("v1/admin/customers", body)
        : await PUT("v1/admin/customers/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  CheckAccount = async () => {
    const { bank_code, bank_account_number } = this.state;
    loading(true);
    let result = await POST("v1/admin/customers/verify-bank-account", {
      bank_code,
      bank_account_number,
    });
    if (result?.data) {
      alert(
        "",
        "success",
        "Bank Account Validated",
        "Your bank account details have been verified and are correct."
      );
    } else {
      alert(
        "",
        "warning",
        "Bank Account Verification Failed",
        "Your bank account couldn’t be verified. Please make sure the information is correct."
      );
    }
    loading(false);
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_currency,
      filter_is_blacklist,

      hover_index,

      data,
      count,
      page,
      page_size,
      loaded,
      data_bank,
      broker_id,
      currency,
      name_th,
      customer_ref,
      name_en,
      email,
      bank_code,
      bank_account_name_th,
      bank_account_name_en,
      bank_account_number,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <div className="ar-title">Customers Management</div>
                <div className="ar-subtitle">Manage agent customers</div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold customers.create"
                  onClick={async () => {
                    this.setState({
                      id: "",
                      uid: "",
                      broker_id:
                        profile?.user_type === "broker" ? profile?.broker?.uid : "",
                      name_th: "",
                      customer_ref: "",
                      name_en: "",
                      email: "",
                      deposit_fee_type: "",
                      deposit_fee_value: "",
                      withdrawal_fee_type: "",
                      withdrawal_fee_value: "",
                      is_vat: false,
                      bank_code: "",
                      bank_account_name_th: "",
                      bank_account_name_en: "",
                      bank_account_number: "",
                      company_name: "",
                      company_address: "",
                      company_website: "",
                      contact_name: "",
                      contact_email: "",
                      contact_phone: "",
                      remark: "",
                      callback_url: "",
                      data_bank: [],
                      is_active: true,
                      modal_create: true,
                    });
                    if (profile?.user_type === "broker") {
                      this.GetBank(profile?.broker?.gateway_deposits || "");
                    }
                  }}
                >
                  <span className="icon me-2">{"\uf234"}</span>Create Customer
                </button>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Blacklist</span>
                <Select
                  className="form-control"
                  placeholder="Select Blacklist"
                  options={[
                    { value: "", label: "Select Blacklist" },
                    { value: true, label: "Blacklist" },
                    { value: false, label: "No Blacklist" },
                  ]}
                  value={filter_is_blacklist}
                  onChange={(v) => {
                    this.setState({ filter_is_blacklist: v });
                  }}
                  default={false}
                />
                </div>
                <div className="ar-toolbar-actions">
              <button
                className="ar-btn-gold"
                onClick={() => {
                  this.Get(1);
                }}
              >
                <span className="icon me-2">{"\uf002"}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() =>
                    this.setState(
                      {
                        filter_search: "",
                        filter_currency: "THB",
                        filter_is_blacklist: "",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                Reset
              </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                {global.currency?.map((item) => (
                  <button
                    className={`ar-pill ${
                      item.currency_code === filter_currency ? "active" : ""
                    }`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    {item.image}
                    {item.currency_code}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf0c0"}</span>
                  Customers
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">UID</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-nowrap">Account Number</td>
                    <td className="text-nowrap">Total Deposits</td>
                    <td className="text-nowrap">Total Withdrawals</td>
                    <td className="text-center text-nowrap wpx-100">KYC</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                    <td className="text-center text-nowrap wpx-100">CFR</td>
                    <td className="text-center customers.update td-actions">
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="UID" className="text-nowrap">
                        <div className="d-flex justify-content-between align-items-center">
                          {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                          <span
                            className="icon pointer ms-2"
                            title="Copy"
                            onClick={() => {
                              copyText(item.uid || "");
                            }}
                          >
                            {"\uf0c5"}
                          </span>
                        </div>
                      </td>
                      <td data-label="Customer" className="text-nowrap">
                        {item.name_en || item.name_th || "-"}
                      </td>
                      <td data-label="Bank" className="text-nowrap">
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div>
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2"
                            />
                            {item.bank_code}
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td data-label="Account Number" className="text-nowrap">
                        {maskAccount(item.bank_account_number) || "-"}
                      </td>
                      <td
                        data-label="Total Deposits"
                        className="text-nowrap py-1"
                      >
                        <div>
                          <div style={{ height: 14 }}>
                            {toFixed(item.total_deposits, 2) || "0.00"}
                          </div>
                          <small
                            className={
                              item.order_deposits
                                ? "text-primary"
                                : "text-secondary"
                            }
                          >
                            {item.order_deposits || 0} orders
                          </small>
                        </div>
                      </td>
                      <td
                        data-label="Total Withdrawals"
                        className="text-nowrap py-1"
                      >
                        <div>
                          <div style={{ height: 14 }}>
                            {toFixed(item.total_withdrawals, 2) || "0.00"}
                          </div>
                          <small
                            className={
                              item.order_withdrawals
                                ? "text-primary"
                                : "text-secondary"
                            }
                          >
                            {item.order_withdrawals || 0} orders
                          </small>
                        </div>
                      </td>
                      <td data-label="KYC" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">{this.renderKyc(item)}</div>
                      </td>
                      <td
                        data-label="Status"
                        className="text-nowrap text-center"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {item.is_active
                            ? Status("active", "success")
                            : Status("inactive", "danger")}
                        </div>
                      </td>
                      <td
                        data-label="CFR"
                        className="text-nowrap text-center"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {item.risk_level === "LOW"
                            ? Status("LOW", "warning")
                            : item.risk_level === "MEDIUM"
                            ? Status("MEDIUM", "orange")
                            : item.risk_level === "HIGH"
                            ? Status("HIGH", "danger")
                            : item.risk_level === "CRITICAL"
                            ? Status("CRITICAL", "dark")
                            : item.is_blacklist
                            ? Status("BLACKLIST", "secondary")
                            : "-"}
                          {item.is_blacklist ? (
                            <div
                              className="position-relative pointer"
                              onMouseEnter={() =>
                                this.setState({ hover_index: index })
                              }
                              onMouseLeave={() =>
                                this.setState({ hover_index: null })
                              }
                            >
                              {Status(
                                <span className="icon">{"\uf0eb"}</span>,
                                "secondary"
                              )}
                              {hover_index === index && (
                                <div
                                  className="position-absolute bg-white rounded-3 shadow p-2 text-start text-wrap"
                                  style={{
                                    right: 40,
                                    top: 0,
                                    zIndex: 10,
                                    minWidth: 220,
                                    maxWidth: 320,
                                  }}
                                >
                                  {item.risk_detail ||
                                    "Your account requires additional review before proceeding."}
                                </div>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </td>
                      <td
                        data-label="Actions"
                        className="text-center customers.update td-actions"
                      >
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`broker-customer-actions-${index}`}>
                            Action
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item
                              className="pu-action-item customers.update"
                              onClick={() => {
                                if (item.broker?.gateway_deposits) {
                                  this.GetBank(item.broker?.gateway_deposits);
                                }
                                this.setState({
                                  ...item,
                                  broker_id: item.broker?.uid || "",
                                  kyc_status: item.gateway_register?.find((g) => g.gateway_name === "primerlo")?.kyc_status || "",
                                  modal_update: true,
                                });
                              }}
                            >
                              <span className="icon">{"\uf044"}</span>Edit
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={10}
                        className="text-center text-secondary py-4"
                      >
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, value) => this.Get(value)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New customer" : "Edit customer"}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : modal_update ? "Update" : ""} Customer
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section-title">
              <span className="icon">{"\uf0c0"}</span>Basic Information
            </div>

            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Currency{required}</div>
              <Select
                className="form-control"
                placeholder="Currency..."
                options={global.currency?.map((e) => ({
                  label: e.currency_name,
                  value: e.currency_code,
                  front: e.image,
                }))}
                onChange={(e, i) => {
                  this.setState({
                    currency: e,
                    bank_code: "",
                    bank_account_number: "",
                    bank_account_name_th: "",
                    bank_account_name_en: "",
                  });
                }}
                value={currency}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Ref</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Ref..."
                onChange={(e) => {
                  this.setState({ customer_ref: e.target.value });
                }}
                value={customer_ref}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Name TH{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Name TH..."
                onChange={(e) => {
                  this.setState({ name_th: e.target.value });
                }}
                value={name_th}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Name EN{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Name EN..."
                onChange={(e) => {
                  this.setState({ name_en: e.target.value });
                }}
                value={name_en}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Email</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Email..."
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={email}
              />
            </div>
            <div className="pu-section-title mt-4">
              <span className="icon">{"\uf19c"}</span>Bank Information
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Bank Name{required}</div>
              <Select
                className="form-control"
                placeholder="Bank Name..."
                options={data_bank.filter((e) =>
                  e.country?.includes(
                    global.currency?.find((c) => c.currency_code === currency)
                      ?.country || "THAI"
                  )
                )}
                onChange={(e) => {
                  this.setState({ bank_code: e });
                }}
                value={bank_code}
                disabled={!broker_id}
              ></Select>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Account Number{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Account Number..."
                maxLength={20}
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ bank_account_number: e.target.value });
                }}
                value={bank_account_number}
                disabled={!broker_id}
              />

              {currency === "LAK" && (
                <button
                  className="btn btn-dark mx-2 ms-2"
                  onClick={() => {
                    if (!bank_code) {
                      alert("", "warning", "Warning", "Please select Bank");
                      return;
                    } else if (!bank_account_number) {
                      alert(
                        "",
                        "warning",
                        "Warning",
                        "Please input Account Number"
                      );
                      return;
                    }
                    this.CheckAccount();
                  }}
                >
                  Verify
                </button>
              )}
            </div>
            {currency === "LAK" && (
              <div className="d-flex mb-3">
                <div className="wpx-150" />
                <small className="text-secondary">
                  To verify your bank account, please fill in your{" "}
                  <b>Bank Name</b> and <b>Account Number</b>.
                </small>
              </div>
            )}
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Account NameTH{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Account NameTH..."
                onChange={(e) => {
                  this.setState({ bank_account_name_th: e.target.value });
                }}
                value={bank_account_name_th}
                disabled={!broker_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Account NameEN{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Account NameEN..."
                onChange={(e) => {
                  this.setState({ bank_account_name_en: e.target.value });
                }}
                value={bank_account_name_en}
                disabled={!broker_id}
              />
            </div>
            {/* ลิงก์หน้า KYC: เฉพาะตอนแก้ไขและ broker ของลูกค้าใช้ primerlo (ลิงก์ออกจาก Backend อายุ 24 ชม.) */}
            {modal_update && this.state.broker?.uses_primerlo && (
              <>
                <div className="pu-section-title mt-4">
                  <span className="icon">{"\uf2c2"}</span>KYC
                  {this.state.kyc_status ? <span className="ms-2">{Status(this.state.kyc_status, KYC_COLORS[this.state.kyc_status] || "secondary")}</span> : null}
                </div>
                <div className="d-flex flex-wrap gap-2 mb-2">
                  <button type="button" className="btn btn-sm btn-outline-warning" onClick={() => this.OpenKyc({ uid: this.state.uid })}>
                    <span className="icon me-1">{"\uf2c2"}</span>Open KYC page
                  </button>
                  <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.OpenKyc({ uid: this.state.uid }, true)}>
                    <span className="icon me-1">{"\uf0c5"}</span>Copy KYC link
                  </button>
                </div>
                <small className="text-secondary d-block mb-3">Send this link to the customer to verify identity and add a bank account. The link expires in 24 hours.</small>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1 rounded-pill"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
